// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a47f8be9","455":"768d9635","977":"0d26c277"}[chunkId] + ".chunk.js";
};